import {useMemo, useRef} from "react";
import {useConfigContext} from "../../../ConfigProvider.tsx";
import {useAutocomplete} from "../../context/GlobalContext";
import {Panel} from "../Panel/Panel";
import {Product} from "../Product/Product";
import {ShowAllButton} from "../ShowAllButton/ShowAllButton";

export function Products() {
    const {autocompleteState: {collections, query, status}, autocomplete} = useAutocomplete();
    const {tc} = useConfigContext();
    const listRef = useRef<HTMLOListElement>(null);
    const items = useMemo(() => {
        const productCollections = collections.filter(({source}) => source.sourceId === "products");
        return productCollections[0]?.items || [];
    }, [collections]);
    if (!query) return <></>;
    if (items.length === 0 && status !== "loading") return <NoEntries/>;
    return (
        <Panel title={tc.products}>
            <ol className="algoliaAutocompleteProducts marginBottom" ref={listRef} {...autocomplete.getListProps()}>
                {items.map((item) => (
                    <Product
                        key={item.objectID}
                        hit={item}
                        postFixLink={encodeURIComponent(query)}
                    />
                ))}
            </ol>
            <ShowAllButton/>
        </Panel>
    );
}

function NoEntries() {
    const {autocompleteState: {query}} = useAutocomplete();
    const {tc} = useConfigContext();
    return <div className="emptybox">{tc.noEntriesFoundForSearch} <q>{query}</q>.</div>;
}
